<h1 class="title">Vragenlijsten per project</h1>

<table class="table table-hover align-middle">
    <thead>
        <tr>
            <th scope="col">

            </th>
            <th scope="col">
                Projectnaam
            </th>
            <th scope="col">
                Datum gestart
            </th>
            <th scope="col">
                Laatste wijziging
            </th>
            <th scope="col">
                Status
            </th>
            <th scope="col">

            </th>
        </tr>

    </thead>
    <tbody class="table-group-divider">

        @for (project of projects(); track project.id) {
        @let latest = latestQuestionnaire(project);
        <tr (click)="toggle(project)" class="" [ngClass]="{'table-active': project.expanded}">
            <td class="text-end">
                @if (project.questionnaire.length) {
                <span class="chevron">
                    {{ project.expanded ? '▾' : '▸' }}
                </span>
                }
            </td>
            <th scope="row">
                {{ project.name }}
            </th>

            @if (!project.expanded && latest) {
            <td>{{ latest.date_started | date:'mediumDate'}}</td>
            <td>{{ latest.date_edited | date:'medium'}}</td>
            <td>
                <fgai-questionnaire-status [status]="latest.status"></fgai-questionnaire-status>
            </td>
            }
            @else {
            <td></td>
            <td></td>
            <td>
                @if (!project.questionnaire.length) {
                <fgai-questionnaire-status [status]="'NEW'"></fgai-questionnaire-status>
                }
            </td>
            }
            <td>
                @if (!project.questionnaire.length || latest.status === 'APPROVED') {
                <button class="btn btn-dark" (click)="startNewQuestionnaire(project.id, !project.questionnaire.length)"
                    i18n-aria-label aria-label="Start nieuwe vragenlijst">
                    <fa-icon [icon]="faPlus" />
                </button>
                }
                @else {
                <a class="btn btn-dark" [routerLink]="['/questionnaire', latest.id, 'edit']"
                    i18n-aria-label aria-label="Bewerk meest recente vragenlijst">
                    <fa-icon [icon]="faPencil" />
                </a>
                }
            </td>
        </tr>

        @if (project.expanded) {
        @for (q of project.questionnaire; track q.id; let first = $first; let index = $index) {
        <tr>
            <td class="text-end">
                ↳
            </td>
            <th scope="row">
                <a [routerLink]="['/questionnaire', q.id, 'edit']" [queryParams]="{hide_diff: first ? '1': undefined}">
                    Ronde #{{index+1}}
                </a>
            </th>
            <td>{{ q.date_started | date:'mediumDate' }}</td>
            <td>{{ q.date_edited | date:'medium'}}</td>
            <td>
                <fgai-questionnaire-status [status]="q.status"></fgai-questionnaire-status>
            </td>
            <td>
                <a href="/api/questionnaire/{{q.id}}/download/" class="btn btn-dark" aria-label="Download questionnaire">
                    <fa-icon [icon]="faDownload" />
                </a>
            </td>
        </tr>
        }
        }

        }
    </tbody>
</table>
